/**
 * Catálogo centralizado de TURNOS académicos del estudiante.
 * Mantener sincronizado con TURNO_CHOICES en escolar/models.py (EscEstudiante).
 *
 * Catálogo vigente (2026-05): MATUTINO | NOCTURNO | SABATINO | EN_LINEA.
 *
 * Compatibilidad con datos legacy:
 *   - 'VESPERTINO' se mapea visualmente a 'Nocturno' (migración en BD lo normaliza).
 *   - 'MIXTO'      se mapea visualmente a 'En Línea' (migración en BD lo normaliza).
 *   - 'EN-LÍNEA'   (con guion/tilde) se acepta como alias de 'EN_LINEA'.
 */

export const TURNO_OPTIONS = [
  { value: 'MATUTINO', label: 'Matutino' },
  { value: 'NOCTURNO', label: 'Nocturno' },
  { value: 'SABATINO', label: 'Sabatino' },
  { value: 'EN_LINEA', label: 'En Línea' },
];

// Aliases que pueden venir de BD/legacy y deben renderizarse como uno del catálogo vigente.
const TURNO_LEGACY_ALIASES = {
  'VESPERTINO': 'NOCTURNO',
  'MIXTO': 'EN_LINEA',
  'EN-LÍNEA': 'EN_LINEA',
  'EN-LINEA': 'EN_LINEA',
  'ENLINEA': 'EN_LINEA',
};

export const TURNO_LABELS = TURNO_OPTIONS.reduce(
  (acc, opt) => { acc[opt.value] = opt.label; return acc; },
  {}
);

/**
 * Normaliza un valor de turno al catálogo vigente (o lo deja igual si ya es válido).
 */
export function normalizeTurno(value) {
  if (!value) return '';
  const up = String(value).trim().toUpperCase();
  return TURNO_LEGACY_ALIASES[up] || up;
}

/**
 * Devuelve la etiqueta legible del turno (ej. 'Matutino').
 * Si el valor es null/undefined o no está en el catálogo, retorna el fallback.
 */
export function getTurnoLabel(value, fallback = 'No especificado') {
  if (!value) return fallback;
  const normalized = normalizeTurno(value);
  return TURNO_LABELS[normalized] || String(value);
}
